// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberModel {
    static getAttributeTypeMap() {
        return PrescriberModel.attributeTypeMap;
    }
}
PrescriberModel.discriminator = undefined;
PrescriberModel.additionalProperties = false;
PrescriberModel.attributeTypeMap = [
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": "Array<PrescriberSharedGlobalIdModel>"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "nickname",
        "baseName": "nickname",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
    {
        "name": "prescriberLicenses",
        "baseName": "prescriberLicenses",
        "type": "Array<PrescriberLicenseModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<PrescriberSharedExternalIdModel>"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PrescriberSharedAddressModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PrescriberSharedPhoneModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PrescriberSharedEmailAddressModel>"
    },
];
//# sourceMappingURL=prescriberModel.js.map